import { Alert } from "@mui/material";

import { AgentDatasetAccess } from "src/views/assistant/types";
import { useChatStore } from "../../stores/ChatStore";

// Copy from Ben's UX note on #30968.
const agentDatasetAccessMessage = (access: AgentDatasetAccess): string => {
  const name = access.agent_name || "This agent";
  if (access.accessible === 0) {
    return `${name} works from data you do not have access to. It cannot answer from that data for you.`;
  }
  return `${name} normally works from ${access.attached} datasets. You have access to ${access.accessible} of them. Answers may be incomplete.`;
};

/**
 * Warning under the chat header while the active agent's attached datasets
 * are filtered for the current user (#30968). Fed by the turn-initial stream
 * metadata through ChatStore, kept across a same-tab refresh by the persisted
 * store, and cleared on navigation or once the backend stops sending the key.
 */
const AgentDatasetAccessBanner = () => {
  const access = useChatStore((state) => state.agentDatasetAccess);
  if (!access) return null;
  return (
    <Alert
      data-testid="aa-agent-dataset-access-banner"
      severity="warning"
      variant="outlined"
      sx={{ mx: 2, mt: 1 }}
    >
      {agentDatasetAccessMessage(access)}
    </Alert>
  );
};

export default AgentDatasetAccessBanner;
